module.exports = __webpack_public_path__ + "img/mighty_necromancer_small.f8a0c18f.png";